import React from 'react';
import TheCollection from '../assets/FH_3_Presentation_002.webp';

const FlavourDeepDive = () => {
  return (
    <section id="flavour-deep-dive" className="flavour-deep-dive">
      <div className="flavour-content">
        <h2>A SPIRIT FOR EVERY STORY</h2>
        <h3>THE FIRE HOUSE COLLECTION</h3>
        <p>Our collection is a complete experience. It begins with the bold, smokey spark of our Fire Engin Gin. It moves to the rich, charred heart of Smokey Timber Rum. And it finishes with the indulgent, smooth comfort of our Bonfire Toffee Vodka. Three unique, small batch spirits. One shared philosophy.</p>
        <a href="/shop" className="btn">Discover the collection</a>
      </div>
      <div className="flavour-image">
        <img src={TheCollection} alt="Cocktail" />
      </div>
    </section>
  );
};

export default FlavourDeepDive;
